import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthPage() {
  const { login, register } = useAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (isLogin) {
        await login(email, password);
        toast.success("Welcome back");
      } else {
        await register(email, password, name);
        toast.success("Account created");
      }
    } catch (err) {
      const msg = err.response?.data?.detail || "Something went wrong";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <Helmet>
        <title>{isLogin ? "Sign In - Prism Planner" : "Create Account - Prism Planner"}</title>
      </Helmet>
      <div className="auth-container">
        <div className="auth-header">
          <h1 className="auth-title">Prism Planner</h1>
          <p className="auth-subtitle">Drag. Prioritize. Execute.</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <h2 className="auth-form-title">
            {isLogin ? "Sign In" : "Create Account"}
          </h2>

          {!isLogin && (
            <div className="auth-field">
              <label className="auth-label" htmlFor="auth-name">Name</label>
              <input
                className="auth-input"
                id="auth-name"
                type="text"
                placeholder="Your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                data-testid="auth-name-input"
              />
            </div>
          )}

          <div className="auth-field">
            <label className="auth-label" htmlFor="auth-email">Email</label>
            <input
              className="auth-input"
              id="auth-email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="auth-email-input"
            />
          </div>

          <div className="auth-field">
            <label className="auth-label" htmlFor="auth-password">Password</label>
            <input
              className="auth-input"
              id="auth-password"
              type="password"
              placeholder="Min. 6 characters"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              data-testid="auth-password-input"
            />
          </div>

          {error && <div className="auth-error">{error}</div>}

          <button
            className="auth-submit-btn"
            type="submit"
            disabled={loading}
            data-testid="auth-submit-btn"
          >
            {loading ? "..." : isLogin ? "Sign In" : "Create Account"}
          </button>

          <div className="auth-switch">
            <span className="auth-switch-text">
              {isLogin ? "Don't have an account?" : "Already have an account?"}
            </span>
            <button
              type="button"
              className="auth-switch-btn"
              onClick={() => { setIsLogin(!isLogin); setError(""); }}
              data-testid="auth-switch-btn"
            >
              {isLogin ? "Sign Up" : "Sign In"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
